// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Favorite24FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Favorite24Filled: FC<Favorite24FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M22.592 8.962v.01l-.001.017a1.867 1.867 0 0 1-.013.179 4.27 4.27 0 0 1-.069.437c-.075.362-.22.855-.492 1.44-.514 1.102-1.473 2.502-3.251 3.943l-1.068.84c-2.476 1.999-3.925 3.736-4.504 4.495-.106.138-.182.244-.231.313l-.052.075-.011.016-.881 1.338-.908-1.32-.002-.004-.013-.018-.059-.083c-.055-.075-.14-.188-.253-.334a22.834 22.834 0 0 0-1.037-1.232 29.911 29.911 0 0 0-4.142-3.795c-2.025-1.534-3.083-3.05-3.629-4.23a6.597 6.597 0 0 1-.488-1.446 4.314 4.314 0 0 1-.078-.575l-.002-.045v-.032c0-1.696.502-2.968 1.27-3.895.757-.916 1.713-1.424 2.506-1.704a6.164 6.164 0 0 1 3.974-.044c1.379.452 2.276 1.468 2.842 2.394.566-.926 1.464-1.942 2.842-2.394l.243-.075a6.167 6.167 0 0 1 3.49.038l.242.08v.002c.792.28 1.748.788 2.506 1.704.767.927 1.269 2.198 1.269 3.894v.01Z" />
        </svg>
    );
};

export default Favorite24Filled;
